import { Overline } from './TextPreset';
import { styled } from './lib';

const TitleSection = styled(Overline)`
  color: #001454;
`;

export default TitleSection;
